import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class CommonApiErrorsHandler {

    // GENERIC: Send the HttpErrorResponse with status code and it will handle the message that to be shown to the user
    handleError(error: HttpErrorResponse) {
        return throwError(() => new Error('Error in connecting with the Backend server. System definition of the error: '+ error));
    }
}